import Firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const config = {
  apiKey: 'AIzaSyBqaxzY_QmXM75sVkq-UIHQO6B3T8nis9U',
  authDomain: 'narutopia-fc8f4.firebaseapp.com',
  projectId: 'narutopia-fc8f4',
  storageBucket: 'narutopia-fc8f4.appspot.com',
  messagingSenderId: '1033647423144',
  appId: '1:1033647423144:web:1455336de4f94a5432cc9d',
  measurementId: 'G-XTKW0RYQWX',
}

const firebase = Firebase.initializeApp(config)

export { firebase }
